import { render, staticRenderFns } from "./HospitalityInfoPoint.vue?vue&type=template&id=774bf2ec&scoped=true&"
import script from "./HospitalityInfoPoint.vue?vue&type=script&lang=ts&"
export * from "./HospitalityInfoPoint.vue?vue&type=script&lang=ts&"
import style0 from "./HospitalityInfoPoint.vue?vue&type=style&index=0&id=774bf2ec&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774bf2ec",
  null
  
)

export default component.exports